import React, { useState, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../utils/toast";
import ButtonUI from "../material-ui/ButtonUI";
import deleteContracts from "../../api/deleteContracts";
import { AuthContext } from "../../context/Auth/AuthContext";
import { DeleteActionButton } from "../common/ActionIconButton";
import DeleteIcon from "@mui/icons-material/Delete";

const DeleteContractsPopup = ({ setContractsAddedToTrue, id }) => {
  const [open, setOpen] = useState(false);
  const { token } = useContext(AuthContext);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onDeleteContractFormSubmit = async () => {
    const deleteContractFormResponse = await deleteContracts({
      token: token,
      id: id,
    });

    if (deleteContractFormResponse?.code === 200) {
      setContractsAddedToTrue(false);
      setOpen(false);
      showSuccess("Contract is deleted successfully");
    }
  };

  return (
    <div className="dialog-modal">
      <DeleteActionButton onClick={handleClickOpen} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            <DeleteIcon />
          </div>
          <div className="popup-header-title">Delete Contract</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this Contract ?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end" }}>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{
              margin: "15px 0px",
              backgroundColor: "#fff",
              color: "#1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            style={{
              margin: "15px",
              backgroundColor: "#fff",
              color: "##1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            autoFocus={true}
            onClickFunc={() => {
              onDeleteContractFormSubmit();
            }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteContractsPopup;
